export default __webpack_public_path__ + "static/forWhoImg2-7b273eab51fcb4cf0389e61060eda33a.png";